export const scopes = [
  { key: 'clinic', name: 'Clínica', description: 'Cadastros, pacientes e agenda' },
  { key: 'imaging', name: 'Imagem', description: 'Worklist e laudos' },
];

export function getName(key) {
  const scope = scopes.find(item => item.key === key);
  return scope ? scope.name : key;
}

export default scopes;
